import ModalComponent from "./ModalComponent";
import { Select as Select2 } from "../../../components/Select";
import Select from "react-select";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useUnidades } from "../../../hooks/test/useUnidades";
import { AuthContext } from "../../../context/authContext/authContext";
import Swal from "sweetalert2";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocation, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { Spinner } from "../../Spinner";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { EditCreateUnidad } from "./ModalCreateEdit";
import { SocketContext } from "../../../context/SocketContext";

export const GestionEventoRoboCamionesModal = ({
    isOpen,
    onClose,
    unidad,
    eventAction,
    refreshData,
}) => {

    const [form, setForm] = useState({
        negocio_id: unidad.negocio_id || "",
        negocio: unidad.negocio.negocio_nombre || "",
        id_cedis: unidad.cedi.cedis_id || "",
        nombre_cedis: unidad.cedi.nombre_cedis || "",
        id_monitorista: "",
        monitorista: "",
        usuario_registro: "",
        id_unidad: unidad.unidad_id || "",
        id_tipo_unidad: unidad.tipo_unidad_id || "",
        unidad: unidad.unidad_numero || "",
        placas: unidad.unidad_placas || "",
        serie: unidad.unidad_vin || "",
        marca: unidad.unidad_marca || "",
        submarca: unidad.unidad_modelo || "",
        operador: "",
        numero_operador: "",
        posicion_actual: "",
        evento_seguridad_id: unidad.evento_seguridad_id,
        evento_id: "",
        estatus_evento_id: "",
        fecha_hora: "",
        coordenadas_inicio_evento: "",
        coordenadas_fin_evento: "",
        fecha_posicion_actual: "",
        municipio: "",
        estado: "",
        carpeta_investigacion: "",
        activacion_as3: "0",
        chapas_seguridad: "0",
        observaciones: "",
        modus_operandi: "",
        vialidad: "",
        cctv: "0",
        paro_motor: "0",
        tipo_de_apoyo: [],
        predenuncia: "",
        ultimo_contacto_conductor: "",
        spot: unidad.spot || 0,
        usuario_spot: "",
        contraseña_spot: "",
        liga_spot: "",
        fecha_registro: "",
        con_mercancia: "0",
        tripulanteId1: "",
        tripulante1: "",
        numero_tripulante1: "",
        tripulanteId2: "",
        tripulante2: "",
        numero_tripulante2: "",
        tripulanteId3: "",
        tripulante3: "",
        numero_tripulante3: "",
        cajas: [], // [{ id_caja_seca, caja_seca, placas, serie, marca, submarca }]
    });

    const {
        getEventos,
        getStatusEvento,
        getEntidadesFederativas,
        getMunicipiosId,
        postEventoSeguridad,
        getUnidad,
        putRegistroEventoSeguridad,
        postFilesUploads,
        deleteRegistroEventoSeguridad,
        getTipoApoyo,
        getPositionCamiones,
        postValidarArchivo,
        getTripulantesIdNegocio,
        getunidadesNegocio,
        postRegistroEventoSeguridadV2,
        getCatalogos,
        getSeguimientoRegistrosSeguridad,
    } = useUnidades();

    const getLocalDatetime = () => {
        const now = new Date();
        const offset = now.getTimezoneOffset() * 60000;
        const local = new Date(now - offset);
        return local.toISOString().slice(0, 16);
    };

    const timers = require('timers-promises');

    const [loading, setLoading] = useState(false);
    const [entidadesFederativas, setEntidadesFederativas] = useState([]);
    const [eventosRobo, setEventosRobo] = useState([]);
    const [statusEvento, setStatusEvento] = useState([]);
    const [tipoApoyo, setTipoApoyo] = useState([]);
    const { user } = useContext(AuthContext);
    const [listMunicipios, setListMunicipios] = useState([]);
    const [startDate, setStartDate] = useState(getLocalDatetime());
    const [selectedFile, setSelectedFile] = useState(null);
    const [choferes, setChoferes] = useState([]);
    const [maniobristas, setManiobristas] = useState([]);
    // 1. Estado del panel
    const [panelOpen, setPanelOpen] = useState(false);
    const [panelCajaOpen, setPanelCajaOpen] = useState(false);
    const [slotActual, setSlotActual] = useState(null); // 'operador' | 'tripulante1' | 'tripulante2' | 'tripulante3'
    const [busqueda, setBusqueda] = useState('');
    const tripulantes = [1, 2, 3];
    const [listUnidadesCaja, setUnidadesCaja] = useState([]);
    const [actiModal, setActiModal] = useState(false);
    const modalClose = () => setActiModal(false);
    const [marcas, setMarcas] = useState([]);
    const [colores, setColores] = useState([]);
    const [actUnidadId, setActUnidadId] = useState([]);
    const formRef = useRef(form);
    const { socket } = useContext(SocketContext);

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        formRef.current = form;
    }, [form]);

    const resetForm = () => {
        setForm({
            negocio_id: "",
            negocio: "",
            id_cedis: "",
            nombre_cedis: "",
            id_monitorista: "",
            monitorista: "",
            id_unidad: "",
            id_tipo_unidad: "",
            unidad: "",
            placas: "",
            serie: "",
            marca: "",
            submarca: "",
            operador: "",
            numero_operador: "",
            operadaroId: "",
            posicion_actual: "",
            evento_seguridad_id: "",
            evento_id: "",
            estatus_evento_id: "",
            fecha_hora: "",
            coordenadas_inicio_evento: "",
            coordenadas_fin_evento: "",
            fecha_posicion_actual: "",
            municipio: "",
            estado: "",
            carpeta_investigacion: "",
            activacion_as3: "",
            chapas_seguridad: "",
            observaciones: "",
            modus_operandi: "",
            vialidad: "",
            cctv: "",
            paro_motor: "0",
            tipo_de_apoyo: [],
            predenuncia: "",
            ultimo_contacto_conductor: "",
            spot: 0,
            fecha_registro: "",
            tripulanteId1: "",
            tripulante1: "",
            numero_tripulante1: "",
            tripulanteId2: "",
            tripulante2: "",
            numero_tripulante2: "",
            tripulanteId3: "",
            tripulante3: "",
            numero_tripulante3: "",
            cajas: [], // [{ id_caja_seca, caja_seca, placas, serie, marca, submarca }]
        });
        setListMunicipios([]);
    };

    const getMunicipios = async (Id) => {
        let resp = await getMunicipiosId(Id);
        if (!resp.ok) return;
        setListMunicipios(resp.municipios);
    };

    const actUnidad = async () => {
        setLoading(true);
        let r = await getUnidad(formRef.current.id_unidad);
        if (r.ok) {
            let re = await getPositionCamiones(formRef.current.id_unidad);
            if (re.localizacion) await getMunicipios(re.localizacion.entidad.id);

            // Refrescar datos de cada caja consultando su unidad
            const cajasActualizadas = await Promise.all(
                formRef.current.cajas.map(async (c) => {
                    const resCaja = await getUnidad(c.id_caja_seca);
                    if (resCaja.ok) {
                        return {
                            id_caja_seca: c.id_caja_seca,
                            caja_seca: resCaja.unidad.unidad_numero,
                            placas_caja_seca: resCaja.unidad.unidad_placas || "",
                            serie_caja_seca: resCaja.unidad.unidad_vin || "",
                            marca_caja_seca: resCaja.unidad.unidad_marca || "",
                            submarca_caja_seca: resCaja.unidad.unidad_modelo || "",
                        };
                    }
                    // Si falla la consulta, conserva los datos anteriores
                    return c;
                })
            );

            setForm(prev => ({
                ...prev,
                unidad: r.unidad.unidad_numero,
                placas: r.unidad.unidad_placas,
                serie: r.unidad.unidad_vin,
                marca: r.unidad.unidad_marca,
                submarca: r.unidad.unidad_modelo,
                spot: r.unidad.spot,
                posicion_actual: re.posicion_actual,
                fecha_posicion_actual: re.fecha_posicion_actual,
                estado: re.localizacion && re.localizacion.entidad.id,
                municipio: re.localizacion && re.localizacion.municipio.id,
                vialidad: re.localizacion && re.localizacion.direccion,
                cajas: cajasActualizadas,
            }));

            setLoading(false);
        } else {
            setLoading(false);
            Swal.fire({
                title: "Error",
                text: "Error al actualizar registros",
                icon: "error",
            });
        }
    };

    const loadData = async () => {
        setLoading(true);

        let r = await getEntidadesFederativas();
        if (r.ok) setEntidadesFederativas(r.entidades);

        let res = await getEventos();
        if (res.ok) setEventosRobo(res.eventos.camiones);

        let re = await getStatusEvento();
        if (re.ok) setStatusEvento(re.estatus.camiones);

        let respue = await getTipoApoyo();
        if (respue.ok) {
            setTipoApoyo(respue.tipos_apoyo);
        }

        // Consulta de operadores
        let listOp = await getTripulantesIdNegocio(formRef.current.negocio_id, 1);
        if (listOp.ok) {
            setChoferes(listOp.tripulantes);
        } else {
            setChoferes([]);
        }
        // Consulta de tripulantes
        let listTri = await getTripulantesIdNegocio(form.negocio_id, 2);
        if (listTri.ok) {
            setManiobristas(listTri.tripulantes);
        } else {
            setManiobristas([]);
        }

        let listUnidadesCajas = await getunidadesNegocio(formRef.current.negocio_id, 7);

        if (listUnidadesCajas.ok) {
            setUnidadesCaja(listUnidadesCajas.unidades)
        }

        let resCatColores = await getCatalogos(1);
        if (resCatColores.ok) {
            setColores(resCatColores.registros.camiones);
        } else {
            setColores([]);
        }

        let resCatMarcas = await getCatalogos(2);
        if (resCatMarcas.ok) {
            setMarcas(resCatMarcas.camiones.registros);
        } else {
            setMarcas([]);
        }

        if (eventAction === "REGISTRAR") {

            let re = await getPositionCamiones(formRef.current.id_unidad);
            if (!re.ok) {
                Swal.fire({
                    title: "Error",
                    text: re.msg ? re.msg : "No se logró obtener la posición de la unidad.",
                    icon: "error",
                });
            }

            if (re.localizacion) await getMunicipios(re.localizacion.entidad.id);

            setForm(prev => ({
                ...prev,
                negocio_id: prev.negocio_id,
                negocio: prev.negocio,
                id_cedis: prev.id_cedis,
                nombre_cedis: prev.nombre_cedis,
                usuario_registro: user.name,
                fecha_registro: startDate,
                id_unidad: prev.id_unidad,
                unidad: prev.unidad,
                placas: prev.placas,
                serie: prev.serie,
                marca: prev.marca,
                submarca: prev.submarca,
                posicion_actual: re.posicion_actual,
                fecha_posicion_actual: re.fecha_posicion_actual,
                spot: prev.spot,
                estado: re.localizacion && re.localizacion.entidad.id,
                municipio: re.localizacion && re.localizacion.municipio.id,
                vialidad: re.localizacion && re.localizacion.direccion,
            }));

            setLoading(false);
        }
        else if (eventAction === "EDITAR") {

            let respu = await getUnidad(form.id_unidad);
            let res = await getSeguimientoRegistrosSeguridad(form.evento_seguridad_id);
            if (res.ok) {
                let { registro_evento_seguridads: registroEvento, tripulantes, evento, evento_id, ultimo_estatus_id, ultimo_estatus, folio, carpeta_investigacion, predenuncia, cajas, usuario } = res.evento;
                let re = await getPositionCamiones(form.id_unidad);
                const tripulacion = tripulantes?.tripulacion || [];
                setForm(prev => ({
                    ...prev,
                    negocio_id: prev.negocio_id,
                    negocio: prev.negocio,
                    id_cedis: prev.id_cedis,
                    nombre_cedis: prev.nombre_cedis,
                    usuario_registro: usuario.name,
                    id_unidad: prev.id_unidad,
                    unidad: prev.unidad,
                    placas: prev.placas,
                    serie: prev.serie,
                    marca: prev.marca,
                    submarca: prev.submarca,
                    operador: tripulantes?.chofer?.nombre_completo,
                    numero_operador: tripulantes?.chofer?.telefono,
                    tripulanteId1: tripulacion[0]?.tripulante_id || "",
                    tripulante1: tripulacion[0]?.nombre_completo || "",
                    numero_tripulante1: tripulacion[0]?.telefono || "",
                    tripulanteId2: tripulacion[1]?.tripulante_id || "",
                    tripulante2: tripulacion[1]?.nombre_completo || "",
                    numero_tripulante2: tripulacion[1]?.telefono || "",
                    tripulanteId3: tripulacion[2]?.tripulante_id || "",
                    tripulante3: tripulacion[2]?.nombre_completo || "",
                    numero_tripulante3: tripulacion[2]?.telefono || "",
                    nombre_evento: evento?.evento,
                    evento_id: evento_id,
                    estatus_evento_id: ultimo_estatus_id,
                    nombre_estatus_evento: ultimo_estatus,
                    folio: folio,
                    posicion_actual: re.posicion_actual || registroEvento[0].coordenadas_online,
                    fecha_posicion_actual: re.fecha_posicion_actual || registroEvento[0].fecha_coordenadas_online,
                    carpeta_investigacion: carpeta_investigacion || "",
                    predenuncia: predenuncia || "",
                    cajas: cajas.map(c => ({
                        id_caja_seca: c.unidad_id,
                        caja_seca: c.economico,
                        placas_caja_seca: c.placas || "",
                        serie_caja_seca: c.serie || "",
                        marca_caja_seca: c.marca || "",
                        submarca_caja_seca: c.modelo || "",
                    })),
                }));
            } else {
                setLoading(false);
                Swal.fire({
                    title: "Error",
                    text: respu.msg ? respu.msg : "Error al cargar datos, porfavor consulte nuevamente.",
                    icon: "error",
                });
            }
        }
        setLoading(false);
    }

    const handleChange = (event) => {
        setForm({ ...form, [event.target.name]: event.target.value });
    };

    const handleFileUpload = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    // 2. Abrir panel para el slot correcto
    const abrirPanel = (slot) => {
        setSlotActual(slot);
        setBusqueda('');
        setPanelOpen(true);
    };

    const abrirPanelCaja = (slot) => {
        setSlotActual(slot);
        setBusqueda('');
        setPanelCajaOpen(true);
    };

    // 3. Al seleccionar una persona
    const seleccionarPersona = (persona) => {
        if (slotActual === 'operador') {
            setForm(prev => ({
                ...prev,
                operador: persona.nombre_completo,
                numero_operador: persona.telefono,
                operadaroId: persona.tripulante_id,
            }));
        } else {
            const n = slotActual.replace('tripulante', ''); // '1', '2', '3'
            setForm(prev => ({
                ...prev,
                [`tripulante${n}`]: persona.nombre_completo,
                [`numero_tripulante${n}`]: persona.telefono,
                [`tripulanteId${n}`]: persona.tripulante_id,
            }));
        }
        setPanelOpen(false);
    };

    const eliminarTripulante = (n) => {
        setForm(prev => {
            // Obtener lista actual en orden
            const lista = [1, 2, 3]
                .map(i => ({
                    nombre: prev[`tripulante${i}`],
                    telefono: prev[`numero_tripulante${i}`],
                    id: prev[`tripulanteId${i}`],
                }))
                .filter(t => t.nombre); // quitar vacíos

            // Eliminar el seleccionado (posición n-1)
            lista.splice(n - 1, 1);

            // Reconstruir el form ordenado
            const nuevo = { ...prev };

            [1, 2, 3].forEach((i) => {
                if (lista[i - 1]) {
                    nuevo[`tripulante${i}`] = lista[i - 1].nombre;
                    nuevo[`numero_tripulante${i}`] = lista[i - 1].telefono;
                    nuevo[`tripulanteId${i}`] = lista[i - 1].id;
                } else {
                    nuevo[`tripulante${i}`] = '';
                    nuevo[`numero_tripulante${i}`] = '';
                    nuevo[`tripulanteId${i}`] = null;
                }
            });

            return nuevo;
        });
    };

    const registrarEventoRobo = async () => {
        let err = false;

        // validar datos de la unidad para envio completo de informacion
        if (form.placas === "" || form.serie === "" || form.marca === "" || form.submarca === "") {
            toast.error("¡Unidad con datos incompletos! favor de actualizarla", { position: toast.POSITION.BOTTOM_CENTER, });
            err = true;
        }
        // ./
        if (form.evento_id === "") {
            toast.error("Por favor selecciona un evento!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (form.vialidad === "") {
            toast.error("Por favor agrega la vialidad del evento!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (form.posicion_actual === "") {
            toast.error("Por favor agrega las coordenadas de inicio de evento!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (form.estado === "") {
            toast.error("Por favor agrega el estado!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (form.ultimo_contacto_conductor === "") {
            toast.error("¡Por favor selecciona fecha y hora de registro del último contacto con la tripulación!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (!form.municipio || form.municipio === "") {
            toast.error("¡Por favor selecciona el municipio!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (form.spot && (form.usuario_spot === "" || form.contraseña_spot === "" || form.liga_spot === "")) {
            toast.error("¡Datos de unidad spot incompletos, favor de rellenar los 3 campos necesarios!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (err === false) {
            setLoading(true);

            let usuario_spot;
            let contrasenia_spot;
            let liga_spot;
            if (form.spot) {
                usuario_spot = form.usuario_spot;
                contrasenia_spot = form.contraseña_spot;
                liga_spot = form.liga_spot;
            }

            const tripulantes = [
                form.operadaroId,
                form.tripulanteId1,
                form.tripulanteId2,
                form.tripulanteId3
            ].filter(Boolean);

            const payload = {
                tipo_unidad_id: 1,
                unidad_id: form.id_unidad,
                evento_id: form.evento_id,
                municipio_id: form.municipio,
                estado_id: form.estado,
                coordenadas_inicio: form.coordenadas_inicio_evento,
                activacion_as3: form.activacion_as3 ? "SI" : "NO",
                modus_operandi: form.modus_operandi,
                chapa_seguridad: form.chapas_seguridad ? "SI" : "NO",
                vialidad: form.vialidad,
                cctv: form.cctv ? 1 : 0,
                paro_motor: form.paro_motor ? 1 : 0,
                ultimo_contacto_conductor: form.ultimo_contacto_conductor,
                mercancia: form.con_mercancia ? true : false,
                usuario_spot,
                contrasenia_spot,
                liga_spot,
                predenuncia: form.predenuncia,
                carpeta_investigacion: form.carpeta_investigacion,
            };

            if (form.cajas.length > 0) {
                payload.cajas = form.cajas.map(c => c.id_caja_seca);
            }

            // 👇 solo se agrega si hay elementos
            if (tripulantes.length > 0) {
                payload.tripulantes = tripulantes;
            }

            let res = await postRegistroEventoSeguridadV2(payload);

            if (res.ok) {
                let resp = await postEventoSeguridad({
                    "evento_seguridad_id": res.evento_seguridad.evento_seguridad_id,
                    "estatus_evento_id": 2,
                    "fecha_hora": form.fecha_registro,
                    "coordenadas_online": form.posicion_actual,
                    "fecha_coordenadas_online": form.fecha_posicion_actual,
                    "observaciones": form.observaciones,
                });
                if (resp.ok) {
                    setLoading(false);

                    await Swal.fire({
                        title: "REGISTRO DE EVENTO DE ROBO",
                        text: "Guardado correctamente",
                        showConfirmButton: false,
                        icon: "success",
                        timer: 3000
                    });

                    console.log("negocio: ", parseInt(formRef.current.negocio_id));
                    socket.emit("new_event_robo", { idNegocio: parseInt(formRef.current.negocio_id) });
                    socket.emit("traer-unidades-en-ruta_", { idNegocio: parseInt(formRef.current.negocio_id) });
                    onClose();     // 1. cerrar modal
                    resetForm();   // 2. limpiar form
                    refreshData(); // 3. refrescar datos del padre

                } else {
                    setLoading(false);
                    Swal.fire({
                        title: "Error",
                        text: resp.msg,
                        icon: "error",
                    });
                }
            } else {
                setLoading(false);
                console.log("error en registro-seguridad");
                Swal.fire({
                    title: "Error",
                    text: res.msg,
                    icon: "error",
                });
            }
        }
    }

    const actualizarEventoRobo = async () => {
        setLoading(true);
        let resp = false;
        // ✅ Solo crear el formData si hay archivo
        let formData = null;
        if (selectedFile !== null) {
            formData = new FormData();
            formData.append('archivo', selectedFile);
            const validar = await postValidarArchivo(formData);
            if (!validar.ok) {
                setLoading(false);
                return Swal.fire({ title: "¡Lo siento!", text: validar.msg, icon: "info" });
            }
        }
        resp = await postEventoSeguridad({
            "evento_seguridad_id": form.evento_seguridad_id,
            "estatus_evento_id": form.estatus_evento_id,
            "apoyo_tipo_id": form.tipo_de_apoyo,
            "fecha_hora": startDate,
            "coordenadas": form.coordenadas_fin_evento,
            "coordenadas_online": form.posicion_actual,
            "fecha_posicion_actual": form.fecha_posicion_actual,
            "lugar": form.lugar_remitido,
            "observaciones": form.observaciones,
        });

        if (resp.ok) {
            let re = await putRegistroEventoSeguridad({
                "carpeta_investigacion": form.carpeta_investigacion,
                "predenuncia": form.predenuncia,
            }, form.evento_seguridad_id);
            console.log(re);

            if (selectedFile === null) {
                resp = {
                    "ok": true,
                    "msg": "Sin archivos cargados"
                }
            } else {
                resp = await postFilesUploads(formData, resp.registro.registro_evento_id);
                if (!resp.ok) {
                    console.log("error al cargar el archivo: " + resp);
                    Swal.fire({ title: "Error", text: "No se pudo cargar el archivo", icon: "error" });
                }
            }

            if (resp.ok && (form.estatus_evento_id !== 2 && form.estatus_evento_id !== "2")) {
                let res = await deleteRegistroEventoSeguridad(form.evento_seguridad_id);
                if (res.ok) {
                    setLoading(false);

                    Swal.fire({
                        title: "REGISTRO DE EVENTO DE ROBO",
                        text: "Finalizado correctamente",
                        showConfirmButton: false,
                        icon: "success",
                        timer: 3000
                    });
                    // socket.emit("update_event_security");
                    // handleClose();
                    refreshData();
                    resetForm();
                    setSelectedFile(null);
                    socket.emit("new_event_robo", { idNegocio: parseInt(formRef.current.negocio_id) });
                    await timers.setTimeout(3000, 'result').then((res) => {
                        loadData();
                    });
                    onClose();

                } else {
                    setLoading(false);
                    Swal.fire({
                        title: "Error",
                        text: resp.msg,
                        icon: "error",
                    });
                }

            } else if (resp.ok && (form.estatus_evento_id === 2 || form.estatus_evento_id === "2")) {
                setLoading(false);
                Swal.fire({
                    title: "REGISTRO DE EVENTO DE ROBO",
                    text: "Actualizado correctamente",
                    showConfirmButton: false,
                    icon: "success",
                    timer: 3000
                });

                refreshData();
                resetForm();
                setSelectedFile(null);
                onClose();

            } else if (!resp.ok) {
                setLoading(false);
                Swal.fire({
                    title: "Error",
                    text: resp.msg,
                    icon: "error",
                });
            }
        } else {
            setLoading(false);
            Swal.fire({
                title: "Error",
                text: resp.msg,
                icon: "error",
            });
        }
    }

    return (
        <>
            {loading && <Spinner />}
            <ModalComponent
                isOpen={isOpen}
                onClose={onClose}
                onConfirm={() => eventAction === "REGISTRAR" ? registrarEventoRobo() : eventAction === "EDITAR" && actualizarEventoRobo()}
                title={`${eventAction === "REGISTRAR" ? "REGISTRO DE EVENTO" : "ACTUALIZACIÓN DE EVENTO"}`}
                className="registerEventCamiones"
            >
                <div className="row">
                    <div className="col-4 card">
                        <div className="row">
                            <div className="col form-group">
                                <label>Negocio</label>
                                <input
                                    type="text"
                                    className="form-control mb-3"
                                    value={form.negocio}
                                    disabled
                                />
                            </div>
                            <div className="col form-group">
                                <label>Cedis</label>
                                <input
                                    type="text"
                                    className="form-control mb-3"
                                    value={form.nombre_cedis}
                                    disabled
                                />
                            </div>
                            <div className="col form-group">
                                <label>Usuario de registro</label>
                                <input
                                    type="text"
                                    className="form-control mb-3"
                                    value={form.usuario_registro}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-8 card ml-1">
                        <div className="row">
                            {
                                eventAction === "REGISTRAR" && (
                                    <>
                                        <div
                                            style={{
                                                width: "50px"
                                            }}
                                        >
                                            <a
                                                style={{
                                                    fontSize: "25px",
                                                    position: "relative",
                                                    top: "30px",
                                                    color: "#4869fc",
                                                    cursor: "pointer"
                                                }}
                                                onClick={() => {
                                                    setActiModal(true);
                                                    setActUnidadId(form.id_unidad);
                                                }}
                                                title="Editar unidad"
                                            >
                                                <FontAwesomeIcon icon={faPenToSquare} />
                                            </a>
                                        </div>
                                    </>
                                )
                            }
                            <div className="col form-group">
                                <label>Unidad</label>
                                <input
                                    type="text"
                                    className="form-control mb-3"
                                    value={form.unidad}
                                    disabled
                                />
                            </div>
                            <div className="col form-group">
                                <label>Placas</label>
                                <input
                                    type="text"
                                    className="form-control mb-3"
                                    value={form.placas}
                                    disabled
                                />
                            </div>
                            <div className="col form-group">
                                <label>Serie</label>
                                <input
                                    type="text"
                                    className="form-control mb-3"
                                    value={form.serie}
                                    disabled
                                />
                            </div>
                            <div className="col form-group">
                                <label>Marca</label>
                                <input
                                    type="text"
                                    className="form-control mb-3"
                                    value={form.marca}
                                    disabled
                                />
                            </div>
                            <div className="col form-group">
                                <label>Submarca</label>
                                <input
                                    type="text"
                                    className="form-control mb-3"
                                    value={form.submarca}
                                    disabled
                                />
                            </div>
                            <div className={`col form-group pt-3`} style={{ alignContent: "center" }}>
                                {eventAction === "REGISTRAR" && form.cajas.length < 2 && (

                                    <button
                                        style={{ padding: "15px 0" }}
                                        type="button"
                                        className="btn btn-primary w-100"
                                        onClick={() => abrirPanelCaja('caja')}
                                    >
                                        + caja seca
                                    </button>

                                )}
                            </div>
                        </div>
                        {/* Botón agregar caja — solo si hay menos de 2 y es REGISTRAR */}
                        {/* Render dinámico de cajas */}
                        {form.cajas.map((caja, index) => (
                            <div className="row" key={caja.id_caja_seca}>
                                {
                                    eventAction === "REGISTRAR" && (
                                        <>
                                            <div style={{ width: "50px" }}>
                                                <a
                                                    style={{
                                                        fontSize: "25px",
                                                        position: "relative",
                                                        top: "30px",
                                                        color: "#4869fc",
                                                        cursor: "pointer"
                                                    }}
                                                    onClick={() => {
                                                        setActiModal(true);
                                                        setActUnidadId(caja.id_caja_seca);
                                                    }}
                                                    title="Editar unidad"
                                                >
                                                    <FontAwesomeIcon icon={faPenToSquare} />
                                                </a>
                                            </div>
                                        </>

                                    )
                                }
                                <div className="col form-group">
                                    <label>Caja seca {index + 1}</label>
                                    <input type="text" className="form-control" value={caja.caja_seca} disabled />
                                </div>
                                <div className="col form-group">
                                    <label>Placas</label>
                                    <input type="text" className="form-control mb-3" value={caja.placas_caja_seca} disabled />
                                </div>
                                <div className="col form-group">
                                    <label>Serie</label>
                                    <input type="text" className="form-control mb-3" value={caja.serie_caja_seca} disabled />
                                </div>
                                <div className="col form-group">
                                    <label>Marca</label>
                                    <input type="text" className="form-control mb-3" value={caja.marca_caja_seca} disabled />
                                </div>
                                <div className="col form-group">
                                    <label>Submarca</label>
                                    <input type="text" className="form-control mb-3" value={caja.submarca_caja_seca} disabled />
                                </div>
                                {eventAction === "REGISTRAR" && (
                                    <div className="col form-group">
                                        <button
                                            style={{ position: "relative", top: "30px" }}
                                            className="btn btn-outline-danger"
                                            onClick={() =>
                                                setForm(prev => ({
                                                    ...prev,
                                                    cajas: prev.cajas.filter((_, i) => i !== index)
                                                }))
                                            }
                                        >
                                            X
                                        </button>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    <div className="col-3 card">
                        <div className="row">
                            {
                                eventAction === "EDITAR" ? (
                                    <>
                                        <div className="col-12 form-group">
                                            <label>Asunto</label>
                                            <Select2
                                                name="evento_id"
                                                value={form.evento_id}
                                                options={eventosRobo.map((x) => {
                                                    return { value: x.evento_id, text: x.evento };
                                                })}
                                                onChange={(event) => { handleChange(event) }}
                                                className="form-control mt-2"
                                                placeholder="Selecciona evento"
                                            />
                                        </div>
                                        <div className="col-12 form-group">
                                            <label>Estatus Evento</label>

                                            <Select2
                                                name="estatus_evento_id"
                                                value={form.estatus_evento_id}
                                                options={statusEvento.map((x) => {
                                                    return { value: x.estatus_evento_id, text: x.estatus_evento };
                                                })}
                                                className="form-control mt-2 mb-3"
                                                onChange={(event) => { handleChange(event) }}
                                                placeholder="Selecciona estatus evento"
                                            />
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="col form-group">
                                            <label>Asunto</label>
                                            <Select2
                                                name="evento_id"
                                                value={form.evento_id}
                                                options={eventosRobo.map((x) => {
                                                    return { value: x.evento_id, text: x.evento };
                                                })}
                                                onChange={(event) => { handleChange(event) }}
                                                className="form-control mt-2"
                                                placeholder="Selecciona evento"
                                            />
                                        </div>
                                    </>
                                )
                            }
                        </div>
                    </div>
                    <div className="col-9 card ml-1">
                        <div className="row">
                            {!form.operador && eventAction === "REGISTRAR" ? (
                                <div className="col-3 mb-3 form-group pt-3">
                                    <button
                                        type="button"
                                        className="btn btn-primary w-100"
                                        onClick={() => abrirPanel('operador')}
                                    >
                                        Agregar operador
                                    </button>
                                </div>
                            ) : (
                                <>
                                    <div className="col-3 mb-3 pt-3 text-center">
                                        <div className="border p-2 rounded">
                                            <div><b>{form.operador}</b></div>
                                            <div style={{ fontSize: '12px' }}>{form.numero_operador}</div>
                                            {
                                                eventAction === "REGISTRAR" && (
                                                    <>
                                                        <button
                                                            className="btn btn-sm btn-link"
                                                            onClick={() => abrirPanel(`operador`)}
                                                        >
                                                            Cambiar
                                                        </button>
                                                    </>
                                                )

                                            }
                                        </div>
                                    </div>
                                </>
                            )}

                            {tripulantes.map((n) => {
                                const nombre = form[`tripulante${n}`];
                                const telefono = form[`numero_tripulante${n}`];

                                return (
                                    <React.Fragment key={n}>
                                        {!nombre && eventAction === "REGISTRAR" ? (
                                            <>
                                                <div className="col-3 mb-3 pt-3 text-center">
                                                    <button
                                                        className="btn btn-outline-primary w-100"
                                                        onClick={() => abrirPanel(`tripulante${n}`)}
                                                    >
                                                        Agregar tripulante {n}
                                                    </button>
                                                </div>
                                            </>
                                        ) : nombre && eventAction === "REGISTRAR" ? (
                                            <div className="col-3 mb-3 pt-3 text-center">
                                                <div className="border p-2 rounded">
                                                    <div><b>{nombre}</b></div>
                                                    <div style={{ fontSize: '12px' }}>{telefono}</div>

                                                    <button
                                                        className="btn btn-sm btn-link"
                                                        onClick={() => abrirPanel(`tripulante${n}`)}
                                                    >
                                                        Cambiar
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => eliminarTripulante(n)}
                                                    >
                                                        Eliminar
                                                    </button>
                                                </div>
                                            </div>
                                        ) : nombre && (
                                            <>
                                                <div className="col-3 mb-3 pt-3 text-center">
                                                    <div className="border p-2 rounded">
                                                        <div><b>{nombre}</b></div>
                                                        <div style={{ fontSize: '12px' }}>{telefono}</div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                        }
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                </div>
                {
                    eventAction === "REGISTRAR" ? (
                        <>
                            <div className="row mt-4">
                                <div className="col-2">
                                    <div className="form-group">
                                        <label>Fecha y hora</label>
                                        <input
                                            type="datetime-local"
                                            name="fecha_registro"
                                            className="form-control mt-2"
                                            value={form.fecha_registro}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label>Vialidad</label>
                                        <input
                                            type="text"
                                            name="vialidad"
                                            autoComplete="off"
                                            className="form-control mb-3"
                                            value={form.vialidad}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label>Coordenadas inicio evento</label>
                                        <input
                                            type="text"
                                            autoComplete="off"
                                            name="coordenadas_inicio_evento"
                                            className="form-control mb-3"
                                            value={form.coordenadas_inicio_evento}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2 mb-3">

                                    <label>Coordenadas registro</label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <a
                                                style={{
                                                    padding: "15px 20px",
                                                    position: "relative",
                                                    background: "#ffcd00",
                                                    top: "23px",
                                                    cursor: "pointer"
                                                }}
                                                data-toggle="tooltip"
                                                title={
                                                    form.fecha_posicion_actual && form.fecha_posicion_actual != "" ? (
                                                        moment(form.fecha_posicion_actual).format("YYYY-MM-DD HH:mm:ss")
                                                    ) : ""
                                                }
                                                onClick={() => {
                                                    if (!form.posicion_actual) return;
                                                    let array = form.posicion_actual.split(",");
                                                    window.open(
                                                        `https://www.google.es/maps?q=${array[0]},${array[1]}`
                                                    )
                                                }}

                                            >
                                                <FontAwesomeIcon icon={faMapLocation} />
                                            </a>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="posicion_actual"
                                            value={
                                                form.fecha_posicion_actual && form.fecha_posicion_actual != "" ? (
                                                    form.posicion_actual
                                                ) : ""
                                            }
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label>Estado</label>
                                        {
                                            eventAction === "REGISTRAR" ? (
                                                <>
                                                    <select
                                                        className="form-control mt-2"
                                                        onChange={(event) => {
                                                            setForm({ ...form, estado: event.target.value });
                                                            getMunicipios(event.target.value);
                                                        }}
                                                        value={form.estado}
                                                        defaultValue
                                                    >
                                                        <option value="" selected={true} disabled>
                                                            ---
                                                        </option>
                                                        {entidadesFederativas.map((x) => {
                                                            return (
                                                                <option value={x.entidad_federativa_id} key={x.entidad_federativa_id}>
                                                                    {x.entidad_federativa}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </>
                                            ) : ""
                                        }
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label>Alcaldía/Municipio</label>
                                        {
                                            eventAction === "REGISTRAR" ? (
                                                <>
                                                    <Select2
                                                        options={listMunicipios.map((x) => {
                                                            return { value: x.municipio_id, text: x.municipio };
                                                        })}
                                                        className="form-control mt-2"
                                                        onChange={(event) =>
                                                            setForm({ ...form, municipio: event.target.value })
                                                        }
                                                        value={form.municipio}
                                                        defaultValue
                                                        placeholder="Selecciona tu municipio"
                                                        required
                                                    />
                                                </>
                                            ) : ""

                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-2">
                                    <div className="form-group">
                                        <div className="form-check" style={{ margin: "35px" }}>
                                            <input
                                                name="activacion_as3"
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={(event) => {
                                                    setForm({ ...form, activacion_as3: event.target.checked })
                                                }}
                                                checked={form.activacion_as3 ? true : false}
                                            />
                                            <label className="form-check-label">
                                                AS3
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <div className="form-check" style={{ margin: "35px" }}>
                                            <input
                                                name="chapas_seguridad"
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={(event) => {
                                                    setForm({ ...form, chapas_seguridad: event.target.checked })
                                                }}
                                                checked={form.chapas_seguridad ? true : false}
                                            />
                                            <label className="form-check-label">
                                                Chapa seguridad
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-check" style={{ margin: "35px" }}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            onChange={(event) => {
                                                setForm({ ...form, paro_motor: event.target.checked })
                                            }}
                                            checked={form.paro_motor ? true : false}
                                        />
                                        <label className="form-check-label">
                                            Paro de motor
                                        </label>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-check" style={{ margin: "35px" }}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            onChange={(event) => {
                                                setForm({ ...form, cctv: event.target.checked })
                                            }}
                                            checked={form.cctv ? true : false}
                                        />
                                        <label className="form-check-label">
                                            CCTV
                                        </label>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-check" style={{ margin: "35px" }}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            onChange={(event) => {
                                                setForm({ ...form, con_mercancia: event.target.checked })
                                            }}
                                            checked={form.con_mercancia ? true : false}
                                        />
                                        <label className="form-check-label">
                                            Con mercancía
                                        </label>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label>último contacto con la tripulación </label>
                                        <input
                                            type="datetime-local"
                                            name="ultimo_contacto_conductor"
                                            className="form-control mt-2"
                                            value={form.ultimo_contacto_conductor}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label>Carpeta de investigación:</label>
                                        <input
                                            type="text"
                                            autoComplete="off"
                                            name="carpeta_investigacion"
                                            className="form-control mb-3"
                                            value={form.carpeta_investigacion}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label>Predenuncia:</label>
                                        <input
                                            type="text"
                                            name="predenuncia"
                                            autoComplete="off"
                                            className="form-control mb-3"
                                            value={form.predenuncia}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                {
                                    form.spot ? (
                                        <>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label>Usuario spot</label>
                                                    <input
                                                        type="text"
                                                        name="usuario_spot"
                                                        className="form-control mb-3"
                                                        value={form.usuario_spot}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label>Contraseña spot</label>
                                                    <input
                                                        type="text"
                                                        name="contraseña_spot"
                                                        className="form-control mb-3"
                                                        value={form.contraseña_spot}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label>Liga spot</label>
                                                    <input
                                                        type="text"
                                                        name="liga_spot"
                                                        className="form-control mb-3"
                                                        value={form.liga_spot}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    ) : ""
                                }
                                <div className="col-4">
                                    <div className="form-group">
                                        <label>Nota</label>
                                        <textarea
                                            className="form-control mb-3"
                                            rows="3"
                                            name="observaciones"
                                            value={form.observaciones}
                                            onChange={handleChange}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label>Modus operandi</label>
                                        <textarea
                                            className="form-control mb-3"
                                            rows="3"
                                            name="modus_operandi"
                                            value={form.modus_operandi}
                                            onChange={handleChange}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) :
                        eventAction === "EDITAR" ? (
                            <>
                                <div className="row mt-4">
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Fecha y hora</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                    startDate
                                                }
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="form-group">
                                            <label>Fecha-hora coordenadas de registro</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="fecha_posicion_actual"
                                                value={form.fecha_posicion_actual}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Coordenadas de registro</label>
                                            <input
                                                type="text"
                                                name="posicion_actual"
                                                className="form-control mb-3"
                                                value={form.posicion_actual}
                                                onChange={handleChange}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Coordenadas de seguimiento</label>
                                            <input
                                                type="text"
                                                name="coordenadas_fin_evento"
                                                className="form-control mb-3"
                                                value={form.coordenadas_fin_evento}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="col form-group">
                                            <label>Corporaciones </label>
                                            <Select
                                                name="tipo_de_apoyo"
                                                options={tipoApoyo.map((x) => {
                                                    return { value: x.apoyo_tipo_id, label: x.apoyo_tipo };
                                                })}
                                                isMulti
                                                className="form-control mt-2"
                                                classNamePrefix={"select"}
                                                value={form.tipo_de_apoyo}
                                                onChange={(event) => {

                                                    let aux = [];
                                                    event.forEach((label) => {
                                                        aux.push(label);
                                                    });

                                                    setForm({ ...form, tipo_de_apoyo: aux })
                                                }}
                                                placeholder="Selecciona el tipo de apoyo"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-5">
                                        <div className="form-group">
                                            <label>Lugar donde será remitida</label>
                                            <input
                                                type="text"
                                                name="lugar_remitido"
                                                className="form-control mb-3"
                                                value={form.lugar_remitido}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Cargar archivo</label>

                                            <input
                                                style={{ marginTop: "8px" }}
                                                name="cargar_archivo"
                                                className="form-control mb-3"
                                                type="file"
                                                accept=".xlsx,.xls, .csv/*,.doc, .docx, .pdf, image/*, video/mp4"
                                                onChange={handleFileUpload}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Carpeta de investigación:</label>
                                            <input
                                                type="text"
                                                name="carpeta_investigacion"
                                                className="form-control mb-3"
                                                value={form.carpeta_investigacion}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="form-group">
                                            <label>Predenuncia:</label>
                                            <input
                                                type="text"
                                                name="predenuncia"
                                                className="form-control mb-3"
                                                value={form.predenuncia}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label>Nota</label>
                                            <textarea
                                                className="form-control mb-3"
                                                rows="3"
                                                name="observaciones"
                                                value={form.observaciones}
                                                onChange={handleChange}
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : ""
                }
                {panelOpen && (
                    <div style={{
                        position: 'absolute', top: '50%', left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 9999,
                        background: 'white',
                        border: '1px solid #ddd',
                        borderRadius: '8px',
                        width: '420px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                    }}>
                        <div style={{ padding: '12px 16px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between' }}>
                            <b>{slotActual === 'operador' ? 'Seleccionar operador' : 'Seleccionar tripulante'}</b>
                            <button style={{ padding: "10px", border: "none" }} onClick={() => setPanelOpen(false)}>×</button>
                        </div>
                        <input
                            type="text"
                            placeholder="Buscar..."
                            value={busqueda}
                            onChange={e => setBusqueda(e.target.value)}
                            style={{ width: '100%', padding: '8px 12px', borderBottom: '1px solid #eee' }}
                        />
                        <div style={{ maxHeight: '220px', overflowY: 'auto' }}>
                            {(slotActual === 'operador' ? choferes : maniobristas)
                                .filter(p => p.nombre_completo.toLowerCase().includes(busqueda.toLowerCase()))
                                .map(p => (
                                    <div
                                        key={p.id}
                                        onClick={() => !p.ocupado && seleccionarPersona(p)}
                                        style={{
                                            padding: '10px 16px',
                                            cursor: p.ocupado ? 'not-allowed' : 'pointer',
                                            opacity: p.ocupado ? 0.4 : 1,
                                        }}
                                        onMouseEnter={e => !p.ocupado && (e.currentTarget.style.background = '#f5f5f5')}
                                        onMouseLeave={e => e.currentTarget.style.background = 'white'}
                                    >
                                        <div>{p.nombre_completo} {p.ocupado && <span style={{ fontSize: '11px', color: '#e74c3c' }}>(Ocupado)</span>}</div>
                                        <div style={{ fontSize: '12px', color: '#888' }}>{p.telefono}</div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                )}

                {
                    panelCajaOpen && (
                        <>
                            <div style={{
                                position: 'absolute', top: '50%', left: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: 9999,
                                background: 'white',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                width: '420px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                            }}>
                                <div style={{ padding: '12px 16px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between' }}>
                                    <b>Seleccionar caja seca</b>
                                    <button style={{ padding: "10px", border: "none" }} onClick={() => setPanelCajaOpen(false)}>×</button>
                                </div>
                                <input
                                    type="text"
                                    placeholder="Buscar..."
                                    value={busqueda}
                                    onChange={e => setBusqueda(e.target.value)}
                                    style={{ width: '100%', padding: '8px 12px', borderBottom: '1px solid #eee' }}
                                />
                                <div style={{ maxHeight: '220px', overflowY: 'auto' }}>
                                    {(slotActual === 'caja' && listUnidadesCaja)
                                        .filter(p => p.unidad_numero.toLowerCase().includes(busqueda.toLowerCase()))
                                        .map(p => {
                                            const noDisponible = !p.unidad_disponible; // 0 = no disponible

                                            return (
                                                <div
                                                    key={p.unidad_id}
                                                    style={{
                                                        padding: '10px 16px',
                                                        cursor: noDisponible ? 'not-allowed' : 'pointer',
                                                        opacity: noDisponible ? 0.4 : 1,
                                                    }}
                                                    onClick={async () => {
                                                        if (noDisponible) return; // bloquear click
                                                        // Máximo 2 cajas
                                                        if (formRef.current.cajas.length >= 2) {
                                                            toast.error("Máximo 2 cajas secas permitidas", {
                                                                position: toast.POSITION.BOTTOM_CENTER,
                                                            });
                                                            setPanelCajaOpen(false);
                                                            return;
                                                        }

                                                        // Evitar duplicados
                                                        if (formRef.current.cajas.some(c => c.id_caja_seca === p.unidad_id)) {
                                                            toast.error("Esta caja ya fue agregada", {
                                                                position: toast.POSITION.BOTTOM_CENTER,
                                                            });
                                                            setPanelCajaOpen(false);
                                                            return;
                                                        }

                                                        let r = await getUnidad(p.unidad_id);
                                                        if (r.ok) {
                                                            setForm(prev => ({
                                                                ...prev,
                                                                cajas: [...prev.cajas, {
                                                                    id_caja_seca: p.unidad_id,
                                                                    caja_seca: p.unidad_numero,
                                                                    placas_caja_seca: r.unidad.unidad_placas,
                                                                    serie_caja_seca: r.unidad.unidad_vin,
                                                                    marca_caja_seca: r.unidad.unidad_marca,
                                                                    submarca_caja_seca: r.unidad.unidad_modelo,
                                                                }]
                                                            }));
                                                        }

                                                        setPanelCajaOpen(false);
                                                    }}
                                                    onMouseEnter={e => e.currentTarget.style.background = '#f5f5f5'}
                                                    onMouseLeave={e => e.currentTarget.style.background = 'white'}
                                                >
                                                    <div>{p.unidad_numero}</div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        </>
                    )
                }
            </ModalComponent >
            {
                actiModal &&
                <EditCreateUnidad
                    negocio_id={form.negocio_id}
                    unidad_id={actUnidadId}
                    marcas={marcas}
                    colores={colores}
                    show={actiModal}
                    handleClose={modalClose}
                    refreshUnidades={() => { actUnidad(); refreshData(); }}
                />
            }
            <ToastContainer />
        </>
    );
};